"use client";

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@devhop/ui";
import type { ShopShiftAssignmentRow } from "@/modules/merchant/presentation/api/client";
import {
  formatShiftTimeShort,
} from "@/modules/merchant/presentation/lib/shift-time-format";
import { SimpleSelect } from "@/shared/ui/SimpleSelect";

export type ShopShiftMySwapDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  branchId: string | undefined;
  sourceOptions: ShopShiftAssignmentRow[];
  targetOptions: ShopShiftAssignmentRow[];
  swapSourceId: string;
  onSwapSourceChange: (id: string) => void;
  swapTargetId: string;
  onSwapTargetChange: (id: string) => void;
  submitting: boolean;
  onSubmit: () => void;
};

export function ShopShiftMySwapDialog({
  open,
  onOpenChange,
  branchId,
  sourceOptions,
  targetOptions,
  swapSourceId,
  onSwapSourceChange,
  swapTargetId,
  onSwapTargetChange,
  submitting,
  onSubmit,
}: ShopShiftMySwapDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>ຂໍແລກກະ</DialogTitle>
          <DialogDescription>
            ເລືອກກະຂອງທ່ານ ແລະ ກະທີ່ຕ້ອງການແລກດ້ວຍ (ວັນດຽວກັນ, ຍັງບໍ່ເຂົ້າງານ)
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <div className="space-y-1.5">
            <span className="font-medium text-muted-foreground text-xs">
              ກະຂອງຂ້ອຍ
            </span>
            <SimpleSelect
              value={swapSourceId}
              onValueChange={onSwapSourceChange}
              options={sourceOptions.map((a) => ({
                value: a.id,
                label: `${a.workDate} · ${formatShiftTimeShort(a.scheduledStartAt)}`,
              }))}
              placeholder="ເລືອກກະ"
              className="h-10 w-full"
            />
          </div>
          <div className="space-y-1.5">
            <span className="font-medium text-muted-foreground text-xs">
              ແລກກັບກະ
            </span>
            <SimpleSelect
              value={swapTargetId}
              onValueChange={onSwapTargetChange}
              options={targetOptions.map((a) => ({
                value: a.id,
                label: `${formatShiftTimeShort(a.scheduledStartAt)} · ${a.staffUserName?.trim() || a.staffUserEmail}`,
              }))}
              placeholder="ເລືອກກະປາຍທາງ"
              className="h-10 w-full"
            />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              ຍົກເລີກ
            </Button>
            <Button
              type="button"
              disabled={
                submitting || !branchId || !swapSourceId || !swapTargetId
              }
              onClick={onSubmit}
            >
              ສົ່ງຄຳຂໍ
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
